import { ApplicationRef, Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { ApiService } from '../api/api.service';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';


@Injectable({
  providedIn: 'root'
})
export class SocketService extends Socket {
  public carte = new BehaviorSubject<any>({});

  constructor(public api: ApiService) {
    console.log("initialisation de sio");
    super({ url: 'https://notification.minoteriedusenegal.com/', options: { extraHeaders: { token: api.token.token_key } } });
  }
  update(data: any) {
    console.log("send: ", data)
    this.emit('update', data);
  }
  getSocket(): any {
    return this
  }
  on_change(message_add: any, message_edit: any, callback: (data: any) => void) {
    this.on('connect', () => {
      // console.log("connect = ", data);

      this.on('message', (data: any) => {
        // console.log('ws', data);
        this.carte.next(data);
        if (data.type == message_add || data.type == message_edit) {
          // console.log("message = ", data);
          callback(data); // Exécuter la fonction de rappel fournie
        }
      });
    });
  }
  on_update(callback: (data: any) => void) {
    this.on('connect', () => {
      //console.log("connect = ", data);
      this.on('update', (data: any) => {
        console.log("update = ", data);
        callback(data); // Exécuter la fonction de rappel fournie
      });
    });
  }
  on_change_details(message: any, callback: () => void) {
    this.on('connect', () => {
      console.log("connect = ");
      this.on('message', (data: any) => {
        console.log('message', data);

        if (data.type == message) {
          //console.log("message = ", data);
          callback()
        }
      });
    });
  }
}
